/**
 * WMF's Release 1 Amelia importer runs every 15 minutes. An empty local read
 * cannot distinguish no purchase from a purchase the next scan has not found,
 * so this wording explains latency without claiming a purchase is pending.
 */
export const recentAmeliaPurchaseMessage =
  "If a lesson block was purchased in Amelia recently, it can take up to 15 minutes to appear. Refresh this page shortly.";
